import {
  ChakraBox as Box,
  ChakraFlex as Flex,
  ChakraButton as Button,
  ChakraAlert as Alert,
  ChakraAlertTitle as AlertTitle,
  ChakraAlertDescription as AlertDescription,
  ChakraCloseButton as CloseButton,
  ChakraBadge as Badge,
} from "@airhelp/react-ui-components";
import { trackEvents } from "utils/trackingUtils";
import { useTranslations } from "contexts/LocalizationContext";
import { useReturningUsersNotification } from "hooks";
import { MAX_GRID_WIDTH } from "config/styleConsts";

const RETURNING_USERS_CLICK_EVENT = ["ReturningUsers", "clicked", "Notification"];

const ReturningUsersNotification = () => {
  const { isOpen, onClose, funnelUrl } = useReturningUsersNotification();

  const translations = useTranslations();

  const CTAButtonHandler = () => {
    trackEvents({
      gtmEvent: RETURNING_USERS_CLICK_EVENT,
      mixpanelEvent: undefined,
    });
  };

  if (!isOpen) return null;
  if (!funnelUrl) return null;

  return (
    <Alert background="primary.100" borderBottom="1px" borderColor="greyscale.400" color="greyscale.700">
      <Flex
        width="100%"
        margin="0 auto"
        justifyContent="space-between"
        maxWidth={MAX_GRID_WIDTH}
        alignItems={{ base: "left", md: "center" }}
        direction={{ base: "column", md: "row" }}
      >
        <Flex justifyContent="space-between">
          <Badge
            textTransform="uppercase"
            display={{ base: "none", md: "initial" }}
            alignSelf="center"
            fontSize="xs"
            color="white"
            background="primary.400"
            borderRadius="xl"
            px={2}
            py={1}
            mr={3}
          >
            {translations("returning_user_badge")}
          </Badge>
          <Box mb={{ base: 4, md: 0 }}>
            <AlertTitle display={{ base: "block", md: "none" }}>{translations("returning_user_greeting")}</AlertTitle>
            <AlertDescription display={{ base: "none", md: "initial" }} mr={1}>
              {translations("returning_user_greeting")}
            </AlertDescription>
            <AlertDescription>{translations("returning_user_message")}</AlertDescription>
          </Box>
          <CloseButton
            display={{ base: "initial", md: "none" }}
            color="greyscale.600"
            right={-1}
            top={-1}
            onClick={onClose}
            aria-label="Close notification"
            data-testid="returning-users-close-mobile"
          />
        </Flex>
        <Flex alignItems="center">
          <Button
            as="a"
            href={funnelUrl}
            fontSize="sm"
            py={2}
            minHeight="initial"
            display={{ base: "none", md: "initial" }}
            variant="secondary"
            onClick={CTAButtonHandler}
            data-testid="returning-users-button"
          >
            {translations("returning_user_button")}
          </Button>
          <CloseButton
            display={{ base: "none", md: "initial" }}
            color="greyscale.600"
            right={-1}
            top={-1}
            ml={2}
            onClick={onClose}
            aria-label="Close notification"
            data-testid="returning-users-close"
          />
        </Flex>
        <Button
          as="a"
          href={funnelUrl}
          fontSize="sm"
          py={2}
          minHeight="initial"
          display={{ base: "initial", md: "none" }}
          variant="secondary"
          textAlign="center"
          width="100%"
          onClick={CTAButtonHandler}
          data-testid="returning-users-button-mobile"
        >
          {translations("returning_user_button")}
        </Button>
      </Flex>
    </Alert>
  );
};

export default ReturningUsersNotification;
